module.exports = __webpack_public_path__ + "img/HomeCUSSerial.fad04031.png";